import { zoneLabel } from "@/lib/zones";

const SEV_COLORS = ["#00F076", "#7CE38B", "#FFB800", "#FF8A3D", "#FF2E54", "#B3002D"];

const T = {
  en: { title: "Injury timeline", empty: "No injury or pain logged yet. Entries and Daily Log pain zones appear here week by week.", legend: "Severity", healed: "healed", painDays: "pain days", week: "W" },
  fr: { title: "Timeline des blessures", empty: "Aucune blessure ou douleur enregistrée. Les entrées et zones douloureuses du Suivi Quotidien apparaissent ici semaine par semaine.", legend: "Sévérité", healed: "guéri", painDays: "jours douleur", week: "S" },
};

export const InjuryTimeline = ({ data, lang = "en", selectedZone, onSelectZone }) => {
  const t = T[lang] || T.en;
  const weeks = data?.weeks || [];
  const zones = data?.zones || [];
  const fmt = (iso) => new Date(iso).toLocaleDateString(lang === "fr" ? "fr-FR" : "en-GB", { day: "numeric", month: "short" });

  return (
    <div className="rounded-xl border border-[#1E2638] bg-[#121721] p-6" data-testid="injury-timeline">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div className="font-display font-bold uppercase text-lg">{t.title}</div>
        <div className="flex items-center gap-1 text-[10px] font-mono-tech uppercase text-slate-400">
          {t.legend}
          {SEV_COLORS.map((c, i) => (
            <span key={i} className="inline-flex items-center gap-0.5 ml-1"><span className="w-3 h-3 rounded-sm inline-block" style={{ background: c }} />{i}</span>
          ))}
        </div>
      </div>
      {zones.length === 0 ? (
        <div className="text-slate-500 text-sm" data-testid="injury-timeline-empty">{t.empty}</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs border-separate border-spacing-1" data-testid="injury-timeline-table">
            <thead>
              <tr>
                <th className="text-left font-mono-tech text-[10px] uppercase text-slate-400 pr-2 sticky left-0 bg-[#121721]">Zone</th>
                {weeks.map((w) => <th key={w} className="font-mono-tech text-[10px] text-slate-400 font-normal min-w-[52px]">{fmt(w)}</th>)}
              </tr>
            </thead>
            <tbody>
              {zones.map((z) => (
                <tr key={z.zone} data-testid={`timeline-row-${z.zone}`}>
                  <td className="pr-2 sticky left-0 bg-[#121721]">
                    <button onClick={() => onSelectZone?.(z.zone)} data-testid={`timeline-zone-${z.zone}`}
                      className={`font-semibold whitespace-nowrap hover:text-[#00F076] ${selectedZone === z.zone ? "text-[#00F076]" : "text-white"}`}>
                      {zoneLabel(z.zone, lang)}
                    </button>
                  </td>
                  {z.cells.map((c, i) => {
                    const sev = c.severity;
                    const bg = sev != null ? SEV_COLORS[Math.min(5, sev)] : c.pain_days > 0 ? "rgba(255,46,84,0.25)" : "#090C10";
                    const tip = [
                      sev != null ? `${t.legend} ${sev}${sev === 0 ? ` (${t.healed})` : ""}` : null,
                      c.pain_days ? `${c.pain_days} ${t.painDays}` : null,
                      ...c.events.map((e) => `• ${e.label}`),
                    ].filter(Boolean).join("\n");
                    return (
                      <td key={i} title={tip} className="h-9 rounded-md relative text-center align-middle" style={{ background: bg, opacity: sev != null ? 0.55 + sev * 0.09 : 1 }} data-testid={`timeline-cell-${z.zone}-${i}`}>
                        {c.pain_days > 0 && <span className="font-mono-tech text-[10px] font-bold text-white drop-shadow">{c.pain_days}</span>}
                        {c.events.length > 0 && <span className="absolute top-0.5 right-1 w-1.5 h-1.5 rounded-full bg-white" />}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
